/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Address } from './Address';
import type { AIAnalysis } from './AIAnalysis';
import type { CustomFieldValue } from './CustomFieldValue';
import type { JobRequestFile } from './JobRequestFile';
import type { JobRequestFileLink } from './JobRequestFileLink';
import type { JobRequestSummary } from './JobRequestSummary';
import type { LinguisticQualityReviewResult } from './LinguisticQualityReviewResult';
export type JobRequest = (JobRequestSummary & {
    clientContactId?: number;
    /**
     * True when the requestor was explicitly supplied when the project was created via the external API, as opposed to defaulting to the client contact assigned to the API key.
     */
    requestorProvided?: boolean;
    requestorPhone?: string;
    files?: Array<JobRequestFile>;
    fileLinks?: Array<JobRequestFileLink>;
    notes?: string;
    provideStandardAndRushQuotes?: boolean;
    xtrfServiceId?: number;
    contactAddress?: Address;
    paymentPreferences?: {
        paymentType: JobRequest.paymentType;
        billingAccount?: {
            clientIdNumber: string;
            personalCode?: string;
        };
        billingContact?: Address;
    };
    customFieldValues?: Array<CustomFieldValue>;
    originalFileKey?: string;
    referencedEmails?: Array<string>;
    aiAnalysis?: AIAnalysis;
    statusDetails?: string;
    /**
     * Cause provided by the client when requesting cancellation of the job request
     */
    cancellationRequestCause?: string;
    externalReferenceId?: string;
    quote?: {
        totalAgreed?: number;
        rejectionReason?: string;
        quoteResponseTime?: string;
    };
    linguisticQualityReviewResults?: Array<LinguisticQualityReviewResult>;
});
export namespace JobRequest {
    export enum paymentType {
        CREDIT_CARD = 'CREDIT_CARD',
        BILL_TO_ACCOUNT = 'BILL_TO_ACCOUNT',
        INVOICE_DIRECTLY = 'INVOICE_DIRECTLY',
    }
}

